import React from "react";
import {
  Coins,
  Trophy,
  Wallet,
  CircleDollarSign,
  BookOpen,
  BadgeCheck,
} from "lucide-react";

const PerformanceSection = ({ userData ,userAnalysis}) => {
  const performanceData = [
    {
      title: "Total Earning",
      value: userData?.unifiedWallet?.balance || 0,
      icon: Coins,
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-500",
    },
    {
      title: "Questions Solved",
      value: `${userAnalysis?.totalSolvedQuestions || 0}`,
      icon: BookOpen,
      iconBg: "bg-purple-100",
      iconColor: "text-purple-500",
    },
    {
      title: "Quiz Earnings",
      value: userData?.unifiedWallet?.lockedBalance || 0,
      icon: CircleDollarSign,
      iconBg: "bg-green-100",
      iconColor: "text-green-500",
    },
    {
      title: "Total Balance",
      value: userData?.unifiedWallet?.lifetimeEarned || 0,
      icon: Wallet,
      iconBg: "bg-blue-100",
      iconColor: "text-blue-500",
    },
    {
      title: "Contest Solved",
      value: userData?.joinedContests?.length || 0,
      icon: BadgeCheck,
      iconBg: "bg-pink-100",
      iconColor: "text-pink-500",
    },
    {
      title: "Contest Earnings",
      value: userData?.unifiedWallet?.contestBalance || 0,
      icon: Trophy,
      iconBg: "bg-orange-100",
      iconColor: "text-orange-500",
    },
  ];

  return (
    <div className="rounded-3xl p-2 shadow-[0_20px_50px_rgba(63,63,68,0.08)]">
      
      {/* HEADING */}
      <div className="mb-2 flex items-center justify-between">
        <h3 className="text-2xl font-bold text-slate-800">
          Performance
        </h3>
      </div>

      {/* GRID */}
      <div className="grid grid-cols-2 gap-2 lg:grid-cols-3">
        {performanceData.map((item, index) => {
          const Icon = item.icon;

          return (
            <div
              key={index}
              className="flex  flex-col rounded-2xl border border-[#E7D8F1] bg-[#faf7fd] p-2 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
            >
              
              {/* ICON */}
              <div
                className={`flex h-10 w-16 items-center justify-center rounded-2xl ${item.iconBg}`}
              >
                <Icon className={`h-5 w-5 ${item.iconColor}`} />
              </div>

              {/* CONTENT */}
              <div className="mt-0">
                <p className="text-sm font-medium text-slate-500">
                  {item.title}
                </p>

                <p className="mt-0 text-sm font-bold text-slate-800 break-words">
                  {item.value}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PerformanceSection;